module.exports = __webpack_public_path__ + "img/img7.42196ad4.png";